// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinical-sider {
  --sider-title-size: clamp(0.875rem, 0.82rem + 0.2vw, 0.9375rem); /* 14–15px */
  --sider-facility-size: clamp(0.6875rem, 0.65rem + 0.15vw, 0.75rem); /* 11–12px */
  --sider-nav-size: clamp(0.75rem, 0.7rem + 0.15vw, 0.8125rem); /* 12–13px */
  --sider-group-size: clamp(0.625rem, 0.6rem + 0.1vw, 0.6875rem); /* 10–11px */
  --sider-meta-size: clamp(0.625rem, 0.6rem + 0.1vw, 0.6875rem); /* 10–11px */
  --sider-icon-size: clamp(1rem, 0.95rem + 0.15vw, 1.125rem); /* 16–18px */
  --sider-item-height: clamp(2rem, 1.9rem + 0.25vw, 2.25rem); /* 32–36px */
  --sider-search-height: clamp(2rem, 1.9rem + 0.25vw, 2.25rem);

  box-sizing: border-box;
  width: 256px;
  max-width: min(256px, 28vw);
  height: calc(100vh - 32px);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: width 0.2s ease;
  font-size: var(--sider-nav-size);
}

.clinical-sider--collapsed {
  width: 72px;
  max-width: 72px;
}

.clinical-sider__brand {
  padding: 14px 12px 10px;
  border-bottom: 1px solid #E2E8F0;
  flex-shrink: 0;
  background: #ffffff;
}

.clinical-sider__brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2px;
}

.clinical-sider__logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #F0F9FF;
  border: 1px solid #BAE6FD;
  color: #0284C7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.clinical-sider__title {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: var(--sider-title-size);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.15;
  color: #0F172A;
}

.clinical-sider__facility {
  margin: 2px 0 10px 2px;
  font-size: var(--sider-facility-size);
  font-weight: 400;
  color: #64748B;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clinical-sider__collapse {
  color: #64748B !important;
  margin-inline-start: auto;
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
}

.clinical-sider__search.ant-input-affix-wrapper {
  height: var(--sider-search-height);
  border-radius: 8px !important;
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  padding-inline: 10px !important;
}

.clinical-sider__search.ant-input-affix-wrapper-focused {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.clinical-sider__search .ant-input {
  background: transparent !important;
  font-size: var(--sider-nav-size) !important;
}

.clinical-sider__search .anticon,
.clinical-sider__search-icon {
  font-size: 16px;
  color: #94A3B8;
  flex-shrink: 0;
}

.clinical-sider__icon {
  display: block;
  flex-shrink: 0;
}

.clinical-sider__back {
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 16px);
  margin: 12px 8px 0;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #0284c7;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: start;
}

.clinical-sider__back:hover {
  background: #f0f9ff;
}

.clinical-sider--collapsed .clinical-sider__back {
  justify-content: center;
  width: 36px;
  margin-inline: auto;
  padding: 8px;
}

.clinical-sider__nav {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px 0;
}

.clinical-sider__nav::-webkit-scrollbar {
  width: 5px;
}
.clinical-sider__nav::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 9999px;
}

.clinical-sider__menu.ant-menu {
  border: none !important;
  background: transparent !important;
  font-size: var(--sider-nav-size) !important;
  font-weight: 500;
  color: #475569;
  line-height: 1.25;
}

.clinical-sider__menu .ant-menu-item-group-title {
  padding: 10px 14px 4px !important;
  font-size: var(--sider-group-size) !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8 !important;
  line-height: 1.2;
}

.clinical-sider__menu .ant-menu-item,
.clinical-sider__menu .ant-menu-submenu-title {
  height: var(--sider-item-height) !important;
  line-height: var(--sider-item-height) !important;
  margin: 1px 8px !important;
  width: calc(100% - 16px) !important;
  border-radius: 8px !important;
  padding-inline: 10px !important;
  color: #475569 !important;
  font-size: var(--sider-nav-size) !important;
}

.clinical-sider__menu .ant-menu-item .anticon,
.clinical-sider__menu .ant-menu-submenu-title .anticon,
.clinical-sider__menu .ant-menu-item svg,
.clinical-sider__menu .ant-menu-submenu-title svg,
.clinical-sider__menu .clinical-sider__icon {
  width: var(--sider-icon-size) !important;
  height: var(--sider-icon-size) !important;
  font-size: var(--sider-icon-size) !important;
  color: #64748B;
  stroke: currentColor;
}

.clinical-sider__menu .ant-menu-title-content {
  margin-inline-start: 10px !important;
}

.clinical-sider__menu .ant-menu-item-selected {
  background: #E0F2FE !important;
  color: #0284C7 !important;
  font-weight: 600 !important;
}

.clinical-sider__menu .ant-menu-item-selected .anticon,
.clinical-sider__menu .ant-menu-item-selected svg {
  color: #0EA5E9 !important;
}

.clinical-sider__menu .ant-menu-item:hover,
.clinical-sider__menu .ant-menu-submenu-title:hover {
  background: #F8FAFC !important;
  color: #0F172A !important;
}

.clinical-sider__menu .ant-menu-submenu .ant-menu-item {
  margin-inline-start: 8px !important;
  width: calc(100% - 16px) !important;
  padding-inline-start: 28px !important;
}

.clinical-sider__footer {
  flex-shrink: 0;
  border-top: 1px solid #E2E8F0;
  padding: 10px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.clinical-sider__settings {
  height: var(--sider-item-height);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 10px;
  border: none;
  background: transparent;
  border-radius: 8px;
  color: #475569;
  font-size: var(--sider-nav-size);
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  text-align: start;
}

.clinical-sider__settings:hover {
  background: #F8FAFC;
  color: #0F172A;
}

.clinical-sider__settings.is-active {
  background: #E0F2FE;
  color: #0284C7;
  font-weight: 600;
}

.clinical-sider__settings .anticon,
.clinical-sider__settings .clinical-sider__icon,
.clinical-sider__settings svg {
  color: #64748B;
  stroke: currentColor;
  width: var(--sider-icon-size);
  height: var(--sider-icon-size);
  font-size: var(--sider-icon-size);
}

.clinical-sider__settings.is-active .anticon,
.clinical-sider__settings.is-active .clinical-sider__icon,
.clinical-sider__settings.is-active svg {
  color: #0EA5E9;
}

.clinical-sider__profile {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  min-width: 0;
}

.clinical-sider__profile:hover {
  background: #F1F5F9;
}

.clinical-sider__avatar {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: #E0F2FE;
  border: 1px solid #BAE6FD;
  color: #0284C7;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.clinical-sider__profile-text {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.clinical-sider__profile-name {
  font-size: var(--sider-nav-size) !important;
  font-weight: 600 !important;
  color: #0F172A !important;
  line-height: 1.2 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clinical-sider__profile-role {
  font-size: var(--sider-meta-size);
  color: #64748B;
  line-height: 1.2;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clinical-sider__logout {
  color: #94A3B8 !important;
  flex-shrink: 0;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
}

.clinical-sider__logout:hover {
  color: #EF4444 !important;
  background: #ffffff !important;
}

.clinical-sider--collapsed .clinical-sider__brand-row {
  justify-content: center;
  flex-wrap: wrap;
}

.clinical-sider--collapsed .clinical-sider__collapse {
  margin: 0;
}

.clinical-sider--collapsed .clinical-sider__settings {
  justify-content: center;
  padding: 0;
}

.clinical-sider--collapsed .clinical-sider__profile {
  justify-content: center;
  border: none;
  padding: 4px;
  background: transparent;
}

@media (max-width: 1280px) {
  .clinical-sider {
    --sider-title-size: 0.875rem;
    --sider-facility-size: 0.6875rem;
    --sider-nav-size: 0.75rem;
    --sider-group-size: 0.625rem;
    --sider-meta-size: 0.625rem;
    --sider-icon-size: 1rem;
    --sider-item-height: 2rem;
    --sider-search-height: 2rem;
    width: 240px;
    max-width: 240px;
  }
}

@media (max-width: 1024px) {
  .clinical-sider {
    width: 220px;
    max-width: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/SideBar/style.css"],"names":[],"mappings":"AAAA;EACE,+DAA+D,EAAE,YAAY;EAC7E,kEAAkE,EAAE,YAAY;EAChF,4DAA4D,EAAE,YAAY;EAC1E,8DAA8D,EAAE,YAAY;EAC5E,6DAA6D,EAAE,YAAY;EAC3E,0DAA0D,EAAE,YAAY;EACxE,0DAA0D,EAAE,YAAY;EACxE,4DAA4D;;EAE5D,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,2CAA2C;EAC3C,gDAAgD;EAChD,0BAA0B;EAC1B,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;;;;EAKE,wCAAwC;EACxC,yCAAyC;EACzC,4CAA4C;EAC5C,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".clinical-sider {\n  --sider-title-size: clamp(0.875rem, 0.82rem + 0.2vw, 0.9375rem); /* 14–15px */\n  --sider-facility-size: clamp(0.6875rem, 0.65rem + 0.15vw, 0.75rem); /* 11–12px */\n  --sider-nav-size: clamp(0.75rem, 0.7rem + 0.15vw, 0.8125rem); /* 12–13px */\n  --sider-group-size: clamp(0.625rem, 0.6rem + 0.1vw, 0.6875rem); /* 10–11px */\n  --sider-meta-size: clamp(0.625rem, 0.6rem + 0.1vw, 0.6875rem); /* 10–11px */\n  --sider-icon-size: clamp(1rem, 0.95rem + 0.15vw, 1.125rem); /* 16–18px */\n  --sider-item-height: clamp(2rem, 1.9rem + 0.25vw, 2.25rem); /* 32–36px */\n  --sider-search-height: clamp(2rem, 1.9rem + 0.25vw, 2.25rem);\n\n  box-sizing: border-box;\n  width: 256px;\n  max-width: min(256px, 28vw);\n  height: calc(100vh - 32px);\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  transition: width 0.2s ease;\n  font-size: var(--sider-nav-size);\n}\n\n.clinical-sider--collapsed {\n  width: 72px;\n  max-width: 72px;\n}\n\n.clinical-sider__brand {\n  padding: 14px 12px 10px;\n  border-bottom: 1px solid #E2E8F0;\n  flex-shrink: 0;\n  background: #ffffff;\n}\n\n.clinical-sider__brand-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 2px;\n}\n\n.clinical-sider__logo {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #F0F9FF;\n  border: 1px solid #BAE6FD;\n  color: #0284C7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 16px;\n}\n\n.clinical-sider__title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: var(--sider-title-size);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  line-height: 1.15;\n  color: #0F172A;\n}\n\n.clinical-sider__facility {\n  margin: 2px 0 10px 2px;\n  font-size: var(--sider-facility-size);\n  font-weight: 400;\n  color: #64748B;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clinical-sider__collapse {\n  color: #64748B !important;\n  margin-inline-start: auto;\n  width: 28px !important;\n  height: 28px !important;\n  min-width: 28px !important;\n}\n\n.clinical-sider__search.ant-input-affix-wrapper {\n  height: var(--sider-search-height);\n  border-radius: 8px !important;\n  background: #F8FAFC !important;\n  border-color: #E2E8F0 !important;\n  padding-inline: 10px !important;\n}\n\n.clinical-sider__search.ant-input-affix-wrapper-focused {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.clinical-sider__search .ant-input {\n  background: transparent !important;\n  font-size: var(--sider-nav-size) !important;\n}\n\n.clinical-sider__search .anticon,\n.clinical-sider__search-icon {\n  font-size: 16px;\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n.clinical-sider__icon {\n  display: block;\n  flex-shrink: 0;\n}\n\n.clinical-sider__back {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: calc(100% - 16px);\n  margin: 12px 8px 0;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #0284c7;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: start;\n}\n\n.clinical-sider__back:hover {\n  background: #f0f9ff;\n}\n\n.clinical-sider--collapsed .clinical-sider__back {\n  justify-content: center;\n  width: 36px;\n  margin-inline: auto;\n  padding: 8px;\n}\n\n.clinical-sider__nav {\n  flex: 1;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.clinical-sider__nav::-webkit-scrollbar {\n  width: 5px;\n}\n.clinical-sider__nav::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 9999px;\n}\n\n.clinical-sider__menu.ant-menu {\n  border: none !important;\n  background: transparent !important;\n  font-size: var(--sider-nav-size) !important;\n  font-weight: 500;\n  color: #475569;\n  line-height: 1.25;\n}\n\n.clinical-sider__menu .ant-menu-item-group-title {\n  padding: 10px 14px 4px !important;\n  font-size: var(--sider-group-size) !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94A3B8 !important;\n  line-height: 1.2;\n}\n\n.clinical-sider__menu .ant-menu-item,\n.clinical-sider__menu .ant-menu-submenu-title {\n  height: var(--sider-item-height) !important;\n  line-height: var(--sider-item-height) !important;\n  margin: 1px 8px !important;\n  width: calc(100% - 16px) !important;\n  border-radius: 8px !important;\n  padding-inline: 10px !important;\n  color: #475569 !important;\n  font-size: var(--sider-nav-size) !important;\n}\n\n.clinical-sider__menu .ant-menu-item .anticon,\n.clinical-sider__menu .ant-menu-submenu-title .anticon,\n.clinical-sider__menu .ant-menu-item svg,\n.clinical-sider__menu .ant-menu-submenu-title svg,\n.clinical-sider__menu .clinical-sider__icon {\n  width: var(--sider-icon-size) !important;\n  height: var(--sider-icon-size) !important;\n  font-size: var(--sider-icon-size) !important;\n  color: #64748B;\n  stroke: currentColor;\n}\n\n.clinical-sider__menu .ant-menu-title-content {\n  margin-inline-start: 10px !important;\n}\n\n.clinical-sider__menu .ant-menu-item-selected {\n  background: #E0F2FE !important;\n  color: #0284C7 !important;\n  font-weight: 600 !important;\n}\n\n.clinical-sider__menu .ant-menu-item-selected .anticon,\n.clinical-sider__menu .ant-menu-item-selected svg {\n  color: #0EA5E9 !important;\n}\n\n.clinical-sider__menu .ant-menu-item:hover,\n.clinical-sider__menu .ant-menu-submenu-title:hover {\n  background: #F8FAFC !important;\n  color: #0F172A !important;\n}\n\n.clinical-sider__menu .ant-menu-submenu .ant-menu-item {\n  margin-inline-start: 8px !important;\n  width: calc(100% - 16px) !important;\n  padding-inline-start: 28px !important;\n}\n\n.clinical-sider__footer {\n  flex-shrink: 0;\n  border-top: 1px solid #E2E8F0;\n  padding: 10px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.clinical-sider__settings {\n  height: var(--sider-item-height);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 10px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  color: #475569;\n  font-size: var(--sider-nav-size);\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  width: 100%;\n  text-align: start;\n}\n\n.clinical-sider__settings:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.clinical-sider__settings.is-active {\n  background: #E0F2FE;\n  color: #0284C7;\n  font-weight: 600;\n}\n\n.clinical-sider__settings .anticon,\n.clinical-sider__settings .clinical-sider__icon,\n.clinical-sider__settings svg {\n  color: #64748B;\n  stroke: currentColor;\n  width: var(--sider-icon-size);\n  height: var(--sider-icon-size);\n  font-size: var(--sider-icon-size);\n}\n\n.clinical-sider__settings.is-active .anticon,\n.clinical-sider__settings.is-active .clinical-sider__icon,\n.clinical-sider__settings.is-active svg {\n  color: #0EA5E9;\n}\n\n.clinical-sider__profile {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  min-width: 0;\n}\n\n.clinical-sider__profile:hover {\n  background: #F1F5F9;\n}\n\n.clinical-sider__avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  border: 1px solid #BAE6FD;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.clinical-sider__profile-text {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.clinical-sider__profile-name {\n  font-size: var(--sider-nav-size) !important;\n  font-weight: 600 !important;\n  color: #0F172A !important;\n  line-height: 1.2 !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clinical-sider__profile-role {\n  font-size: var(--sider-meta-size);\n  color: #64748B;\n  line-height: 1.2;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clinical-sider__logout {\n  color: #94A3B8 !important;\n  flex-shrink: 0;\n  width: 24px !important;\n  height: 24px !important;\n  min-width: 24px !important;\n}\n\n.clinical-sider__logout:hover {\n  color: #EF4444 !important;\n  background: #ffffff !important;\n}\n\n.clinical-sider--collapsed .clinical-sider__brand-row {\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.clinical-sider--collapsed .clinical-sider__collapse {\n  margin: 0;\n}\n\n.clinical-sider--collapsed .clinical-sider__settings {\n  justify-content: center;\n  padding: 0;\n}\n\n.clinical-sider--collapsed .clinical-sider__profile {\n  justify-content: center;\n  border: none;\n  padding: 4px;\n  background: transparent;\n}\n\n@media (max-width: 1280px) {\n  .clinical-sider {\n    --sider-title-size: 0.875rem;\n    --sider-facility-size: 0.6875rem;\n    --sider-nav-size: 0.75rem;\n    --sider-group-size: 0.625rem;\n    --sider-meta-size: 0.625rem;\n    --sider-icon-size: 1rem;\n    --sider-item-height: 2rem;\n    --sider-search-height: 2rem;\n    width: 240px;\n    max-width: 240px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .clinical-sider {\n    width: 220px;\n    max-width: 220px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
